import { z } from "zod";

export const tcmEncounterSchema = z
  .object({
    id: z.string().uuid(),
    cxId: z.string().uuid(),
    patientId: z.string().uuid(),
    patientName: z.string(),
    patientDateOfBirth: z.string().regex(/^\d{4}-\d{2}-\d{2}$/), // YYYY-MM-DD format
    patientPhoneNumbers: z.array(z.string()),
    patientStates: z.array(z.string()),
    facilityName: z.string(),
    latestEvent: z.enum(["Admitted", "Transferred", "Discharged"] as const),
    class: z.string(),
    admitTime: z
      .string()
      .datetime()
      .transform(val => new Date(val))
      .optional(),
    dischargeTime: z
      .string()
      .datetime()
      .transform(val => new Date(val))
      .nullable()
      .optional(),
    clinicalInformation: z.record(z.unknown()),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    version: z.number().optional(),
    freetextNote: z.string().optional(),
    dischargeSummaryPath: z.string().nullable(),
    eTag: z.string().optional(),
  })
  .strict();
export type TcmEncounter = z.infer<typeof tcmEncounterSchema>;

export const tcmEncounterResponseSchema = z
  .object({
    items: z.array(tcmEncounterSchema),
    meta: z.object({
      itemsOnPage: z.number(),
      itemsInTotal: z.number().optional(),
      prevPage: z.string().optional(),
      nextPage: z.string().optional(),
    }),
  })
  .strict();
export type TcmEncounterResponse = z.infer<typeof tcmEncounterResponseSchema>;

export const updateTcmEncounterResponseSchema = tcmEncounterSchema.partial();
export type UpdateTcmEncounterResponse = z.infer<typeof updateTcmEncounterResponseSchema>;
